"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryStatus = exports.CardOrderDeliveryType = exports.CardOrderManufacturer = exports.CardOrderProcessingStatus = exports.CardOrderDeliveryStatus = exports.CardOrderStatus = void 0;
var CardOrderStatus;
(function (CardOrderStatus) {
    CardOrderStatus["CREATED"] = "CREATED";
    CardOrderStatus["PROCESSING"] = "PROCESSING";
    CardOrderStatus["SENT"] = "SENT";
    CardOrderStatus["RECEIVED"] = "RECEIVED";
    CardOrderStatus["UNDELIVERED"] = "UNDELIVERED";
})(CardOrderStatus = exports.CardOrderStatus || (exports.CardOrderStatus = {}));
var CardOrderDeliveryStatus;
(function (CardOrderDeliveryStatus) {
    CardOrderDeliveryStatus["NOT_RECEIVED"] = "NOT_RECEIVED";
    CardOrderDeliveryStatus["IN_PRODUCTION"] = "IN_PRODUCTION";
    CardOrderDeliveryStatus["SHIPPING_LABEL_CREATED"] = "SHIPPING_LABEL_CREATED";
    CardOrderDeliveryStatus["IN_DELIVERY"] = "IN_DELIVERY";
    CardOrderDeliveryStatus["ON_HOLD"] = "ON_HOLD";
    CardOrderDeliveryStatus["INCORRECT_CARDORDER_ID"] = "INCORRECT_CARDORDER_ID";
    CardOrderDeliveryStatus["UNKNOWN"] = "UNKNOWN";
})(CardOrderDeliveryStatus = exports.CardOrderDeliveryStatus || (exports.CardOrderDeliveryStatus = {}));
var CardOrderProcessingStatus;
(function (CardOrderProcessingStatus) {
    CardOrderProcessingStatus["TO_PROCESS"] = "TO_PROCESS";
    CardOrderProcessingStatus["PROCESSING"] = "PROCESSING";
    CardOrderProcessingStatus["ERROR"] = "ERROR";
})(CardOrderProcessingStatus = exports.CardOrderProcessingStatus || (exports.CardOrderProcessingStatus = {}));
var CardOrderManufacturer;
(function (CardOrderManufacturer) {
    CardOrderManufacturer["MEGACARD"] = "MEGACARD";
    CardOrderManufacturer["NITECREST"] = "NITECREST";
    CardOrderManufacturer["IDEMIA"] = "IDEMIA";
})(CardOrderManufacturer = exports.CardOrderManufacturer || (exports.CardOrderManufacturer = {}));
var CardOrderDeliveryType;
(function (CardOrderDeliveryType) {
    CardOrderDeliveryType["EXPRESS"] = "EXPRESS";
    CardOrderDeliveryType["STANDARD"] = "STANDARD";
})(CardOrderDeliveryType = exports.CardOrderDeliveryType || (exports.CardOrderDeliveryType = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["NOT_RECEIVED"] = "NOT_RECEIVED";
    DeliveryStatus["IN_PRODUCTION"] = "IN_PRODUCTION";
    DeliveryStatus["SHIPPING_LABEL_CREATED"] = "SHIPPING_LABEL_CREATED";
    DeliveryStatus["IN_DELIVERY"] = "IN_DELIVERY";
    DeliveryStatus["ON_HOLD"] = "ON_HOLD";
    DeliveryStatus["INCORRECT_CARDORDER_ID"] = "INCORRECT_CARDORDER_ID";
    DeliveryStatus["UNKNOWN"] = "UNKNOWN";
})(DeliveryStatus = exports.DeliveryStatus || (exports.DeliveryStatus = {}));
//# sourceMappingURL=card-order.js.map